import { ApolloClient, ApolloProvider, InMemoryCache, createHttpLink, from } from '@apollo/client';
import { onError } from "@apollo/client/link/error";
import { RetryLink } from '@apollo/client/link/retry';
import { ApolloLink } from '@apollo/client';
import { ENDPOINTS, SERVICE_URL, BASE_API_URL, BASE_API_URL_FLAT, BASE_WSS_URL_FLAT } from '../constants';
import { HttpLink, split } from '@apollo/client';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';

import { createClient } from 'graphql-ws';
import { getMainDefinition } from '@apollo/client/utilities';
import { httpUrlToWebSocketUrl } from "../utils/httpUrlToWebSocketUrl";
import { relayStylePagination } from "@apollo/client/utilities";
import { setContext } from '@apollo/client/link/context';
import { useAuth } from "../hooks/useAuth";
import { getNewAccessToken } from '../store/actions/auth';

// const { logout } = useAuth();

// const openHttpLink = createHttpLink({
//     uri: ENDPOINTS.openGraphUri,
// });

const openHttpLink = createHttpLink({
    uri: BASE_API_URL_FLAT + "/api/graphql-open/",
});

console.log(' BASE_API_URL_FLAT -- > ', BASE_API_URL_FLAT)
console.log(' openHttpLink -- > ', openHttpLink);

// const authHttpLink = createHttpLink({
//     uri: ENDPOINTS.graphUri,
// });

const authHttpLink = createHttpLink({
    uri: BASE_API_URL_FLAT + "/api/graphql/",
});

const httpLink = split(
    (operation) => operation.getContext().clientName === 'openHttpLink',
    openHttpLink,
    authHttpLink
);

const roundTripLink = new ApolloLink((operation, forward) => {

    // Called before operation is sent to server

    operation.setContext({ start: new Date() });


    return forward(operation).map((data) => {

        // Called after server responds

        const time = new Date() - operation.getContext().start;

        console.log(`Operation ${operation.operationName} took ${time} to complete`);

        return data;

    });

});

// const httpLink2 = split(
//     (operation) => operation.getContext().clientName === 'authHttpLink',
//     authHttpLink,
//     openHttpLink,

// );

console.log("----------------------- apollo setup 1 ---------------")
console.log("BASE_API_URL - ", BASE_API_URL)
console.log('httpUrlToWebSocketUrl(BASE_API_URL_FLAT) --> ',  httpUrlToWebSocketUrl(BASE_API_URL_FLAT));
console.log('base url ws ==>', BASE_WSS_URL_FLAT + '/api/ws/graphql/');

const wsLink = new GraphQLWsLink(createClient({
    //url: httpUrlToWebSocketUrl(BASE_API_URL_FLAT),
    url : BASE_WSS_URL_FLAT + '/api/ws/graphql/',
    options: {
        reconnect: true
    },
    // FIXME: Token is appended before making the websocket connection initiation, currently using document.cookie in auth actions to provide authentication for websockets
    connectionParams: () => {
        return { token: localStorage.getItem("access") }
        // authToken: user.authToken,
    },
}));

console.log("wslink - ", wsLink)
console.log("----------------------- apollo setup 2 ---------------")


const splitLink = split(
    ({ query }) => {
        const definition = getMainDefinition(query);
        return (
            definition.kind === 'OperationDefinition' &&
            definition.operation === 'subscription'
        );
    },
    wsLink,
    httpLink,

);


const authLink = setContext((_, { headers }) => {
    // get the authentication token from local storage if it exists
    const token = localStorage.getItem('access');
    // return the headers to the context so httpLink can read them
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : "",
        }
    }
});

// const logoutLink = onError(({ networkError }) => {
//     if (networkError.statusCode === 401) logout();
// })


const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors)
        graphQLErrors.forEach(({ message, locations, path }) =>
            console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
            )
        );
    // To retry on network errors, we recommend the RetryLink
    // instead of the onError link. This just logs the error.
    if (networkError?.statusCode && networkError.statusCode == 401 && localStorage.getItem("refresh")) {
        // console.log(Object.keys(networkError))
        console.log(`[Network error]: `, networkError.statusCode);
        const oldHeaders = operation.getContext().headers;
        operation.setContext({
            headers: {
                ...oldHeaders,
                authorization: getNewAccessToken(),
            },
        });
        // Retry the request, returning the new observable
        return forward(operation);
    }
});


const retryIf = (error, operation) => {
    const doNotRetryCodes = [500, 400];
    return !!error && !doNotRetryCodes.includes(error.statusCode);
};
const retryLink = new RetryLink({
    delay: {
        initial: 100,
        max: 2000,
        jitter: true,
    },
    attempts: {
        max: 2,
        retryIf,
    },
});

const cache = new InMemoryCache({
    typePolicies: {
        Query: {
            fields: {
                // coins: offsetLimitPagination(),
                executeSearch: relayStylePagination(),
            },
        },
    },
});

export const client = new ApolloClient({
    // uri: ENDPOINTS.graph,
    // link: authLink.concat(splitLink),
    link: from([
        roundTripLink,
        retryLink,
        errorLink,
        // logoutLink,
        authLink,
        splitLink,
    ]),
    cache: cache,
    connectToDevTools: true,

    // Provide some optional constructor fields

    name: 'connected-insights-web-client',
    version: '1.0',
    queryDeduplication: true,
    defaultOptions: {
        watchQuery: {
            fetchPolicy: 'cache-and-network',
        },
    },
});
